import subjectMaker from 'reducersMakers/subjectMaker';
import * as actions from 'actions';

export default subjectMaker({
  updateType: actions.MAGAZINE_CONTRIBUTE_EDITING_UPDATE_SUBJECT,
  resetType: actions.MAGAZINE_CONTRIBUTE_EDITING_RESET
});



/** WEBPACK FOOTER **
 ** ./src/members/state/magazine/magazineContribute/reducer.js
 **/